module.exports = __webpack_public_path__ + "img/selected2-min.05ab71aa.png";